import React from "react";
import {Tile} from "../../../Components/Tile/Tile";
import {locations} from "../../../Utilities/Location";
import {gridConstants, GridContainer} from "../../../Components/Grid";
import {isObjectNullOrEmpty} from "@utilities/Types/objectUtilities";
import {isAdmin} from "@utilities/LocalStorage/storageUtilities";

interface StudentRegistrationDuplicateStudentsViewProps {
    duplicateStudents: Record<string, any>[];
}

export const StudentRegistrationDuplicateStudentsView: React.FC<StudentRegistrationDuplicateStudentsViewProps> = ({
                                                             duplicateStudents,
                                                         }) => {
    return <>
        <GridContainer hasMarginX hasMarginY className={`dashboard`}>
            {
                duplicateStudents.map((student) => {
                    return (
                        <Tile
                            key={student.studentId}
                            iconName={""}
                            isClickable={isAdmin()}
                            to={locations.EDIT_STUDENT.getPath(student.studentId)}
                            medium_columns={duplicateStudents.length === 1 ? `` : gridConstants.column.SIX}
                            large_columns={duplicateStudents.length === 1 ? `` : gridConstants.column.SIX}
                            label={student.fullName}
                            displayLogo={false}>
                            <>
                                <p>{`Date of Birth: ${student.dateOfBirth}`}</p>
                                <p>{`Grade Level: ${student.gradeLevelDescription}`}</p>
                                <p>{`District: ${student.districtName}`}</p>
                                <p>{`Organization: ${isObjectNullOrEmpty(student.organization)? "No organization listed" : student.organization}`}</p>
                            </>
                        </Tile>
                    );
                })
            }
        </GridContainer>
    </>;
}

